import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
var Config = require('../../../../config');

class ModalColumns extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onAcceptColumns = this.onAcceptColumns.bind(this);

		this.state = {
		    show: false,
		    list:[],
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}


	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow() {
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'list_show/by_key?key=DONATIONS_REGISTERED', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({ show: true, list:response});
			}
		})
	}

	handleChange(e){
		var index = this.state.list.findIndex(obj => obj.id === parseInt(e.target.id));

		if(e.target.checked){
			this.state.list[index].active = true;	
		}else{
			this.state.list[index].active = false;
		}

		this.forceUpdate();

	}

	onAcceptColumns(){
		this.setState({show:false});
		this.props.saveColumns(this.state.list);
	}

	render(){
		const { t } = this.props;

		return(
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Listado</Modal.Title>
		        </Modal.Header>
		        <Modal.Body style={{fontSize: "11px",}}>
		        	<form noValidate>
			        	<div className="row" >
			        		<div className="col-xs-12">
			        			<h4>Mostrar en el Listado</h4>
			        		</div>
			        		<div className="col-xs-12">
			        			{this.state.list.map((l, i)=>{
			        				return <div key={i} className="col-xs-12 col-sm-3">
			        					<input type="checkbox" checked={l.active} id={l.id} 
			        						style={{marginRight:"5px"}} onChange={this.handleChange} />
			        					<span className="span-min">{l.column_name}</span>
			        				</div>
			        			})}
				 			</div>
						</div>
					</form>
						
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.accept')} onClick={this.onAcceptColumns} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalColumns) 